
import Content_fa from "./Content-fa.json";
import Content_en from "./Content-en.json";
import Content_ab from "./Content-ab.json";



const JsonFile = (language) => {
    const data_fa = Content_fa;
    const data_en = Content_en;
    const data_ab = Content_ab;

    switch (language) {
        case "fa":
            return data_fa;
        case "en":
            return data_en;
        case "ab":
            return data_ab;
        default:
            return data_fa;
    }
}


export default JsonFile;